import pmsInstance from '../instance'

const getChargeSessions = (orderId: string) => {
	return pmsInstance.get('/chargeSessions', { params: { orderId } })
}

export default getChargeSessions
